import { CreateCityForm } from 'views/MergeCities/CreateCityDrawer/CreateCityDrawer'
import {
  AllLocalitiesResponce,
  BaseNameIdType,
  ContractItemType,
  CreateReportBodyType,
  EditLocalitiesBodyType,
  IncedentReasonType,
  LocalitiesResponce,
  MaintenanceEditEquipmentDataParams,
  MaintenanceOrdersParams,
  MaintenanceReportsParams,
  ServiceRequestDataReturn,
  SuitableDealerResponse,
} from '../types/api.types'
import { RegionStats } from '../types/statistics.types'
import buildParams from '../utils/utils/buildParams'
import {
  AgreementRequestResultItem,
  GetAgreementRequestsParams,
} from '../views/Customers/types/customer-filters.types'
import { SimilarCitiesResponse } from '../views/MergeCities/types/merge-cities.types'
import {
  RequestTableParamsType,
  RequestTableResponseType,
} from '../views/RequestsManagement/components/NewRequestsTable/types/new-requests-table.types'
import { RequestsStatisticFilterType } from '../views/RequestsStatistic/hooks/useRequestsStatisticFilters'
import { RequestStatisticResponse } from '../views/RequestsStatistic/types/request-statistic.types'
import {
  CheckSerialResponse,
  LinkToServiceBody,
} from '../views/Service/components/NewDrawers/types/NewDrawers.types'
import {
  MaintenanceOrderResponse,
  MaintenanceReport,
  MaintenanceReportResponse,
} from '../views/ServiceReports/types/maintenance-reports.types'
import {
  SimilarAddressParams,
  SimilarAddressTable,
} from '../views/SimilarAddress/types/similar-address.types'
import { ChangeLinkedRequestForm } from '../views/SingleServiceRequest/hooks/useChangeLinkedRequest'
import { isAdmin } from './AccountService'
import { apiRequest, getUrl } from './ApiService'
import { PrintServiceReportResponse } from './types/api.types'

export const getServiceRequestData = (
  orderId: number,
): Promise<ServiceRequestDataReturn> => {
  return apiRequest({
    url: getUrl(`/maintenance/maintenanceorders/${orderId}/binding/state`),
    method: 'GET',
  })
}

export const getNewContracts = (
  dealerId: string,
): Promise<ContractItemType[]> => {
  return apiRequest({
    url: getUrl(`/user-components/${dealerId}/dealer-contracts`),
    method: 'GET',
  })
}

export const getServiceOrderHistory = (orderId: number): Promise<any> => {
  return apiRequest({
    url: getUrl(`/orderhistory/maintenance-orders/${orderId}`),
    method: 'GET',
  })
}

export const getSelectedLocalities = (
  dealerId: string,
): Promise<LocalitiesResponce> => {
  return apiRequest({
    url: getUrl(`/user-components/${dealerId}/location-bindings/selected`),
    method: 'GET',
  })
}

export const changeSelectedLocalities = (
  dealerId: string,
  body: EditLocalitiesBodyType,
): Promise<AllLocalitiesResponce> => {
  return apiRequest({
    url: getUrl(`/user-components/${dealerId}/location-bindings`),
    method: 'POST',
    jsonBody: body,
  })
}

export const getSuitableDealersToAssign = (
  orderIds: number[],
): Promise<SuitableDealerResponse> => {
  return apiRequest({
    url: getUrl(`/orders/assign/dealer-lookup`),
    method: 'POST',
    jsonBody: orderIds,
  })
}

export const getDealersLocalities = (
  dealerId: string,
): Promise<AllLocalitiesResponce> => {
  return apiRequest({
    url: getUrl(`/user-components/${dealerId}/location-bindings`),
    method: 'GET',
  })
}

export function getRequestsTable(
  params: RequestTableParamsType,
): Promise<RequestTableResponseType> {
  const queryStingParams = buildParams(params)
  return apiRequest({
    url: getUrl(`/orders/getpaged?${queryStingParams}`),
  })
}

export const getActiveOrders = (installedOrderId: number): Promise<any> => {
  return apiRequest({
    url: getUrl(
      `/maintenance/installedorders/${installedOrderId}/service-orders/active`,
    ),
    method: 'GET',
  })
}

export const getIncedentTypeReasons = (): Promise<IncedentReasonType[]> => {
  return apiRequest({
    url: getUrl(`/maintenance/malfunctiontypes`),
    method: 'GET',
  })
}

export const getRequestsByAgreementData = (
  params: GetAgreementRequestsParams,
): Promise<AgreementRequestResultItem[]> => {
  const queryStingParams = buildParams(params)

  return apiRequest({
    url: getUrl(`/maintenance/maintenanceorders/active?${queryStingParams}`),
    method: 'POST',
  })
}

export const getIncedentTypes = (): Promise<BaseNameIdType[]> => {
  return apiRequest({
    url: getUrl(`/maintenance/incidenttypes`),
    method: 'GET',
  })
}

export const checkSerialNumber = (
  serialNumber: string,
): Promise<CheckSerialResponse> => {
  return apiRequest({
    url: getUrl(
      `/maintenance/receivers/${serialNumber}/info?withClosedRequests=${isAdmin()}`,
    ),
    method: 'GET',
  })
}

export const linkRequestToServiceOrder = (
  orderId: number,
  requestId: number,
  body: LinkToServiceBody,
): Promise<any> => {
  return apiRequest({
    url: getUrl(
      `/maintenance/maintenanceorders/${orderId}/service-center/${requestId}`,
    ),
    method: 'POST',
    jsonBody: body,
  })
}

export const createRequestWithLinkToService = (body: any): Promise<any> => {
  return apiRequest({
    url: getUrl(`/maintenance/maintenanceorders/service-center/bind`),
    method: 'POST',
    jsonBody: body,
  })
}

export const createServiceRequestWithServiceCenter = (data: any) => {
  return apiRequest({
    url: getUrl('/maintenance/maintenanceorders/service-center'),
    method: 'POST',
    jsonBody: data,
  })
}

export const sendExistedRequestToServiceCenter = (
  orderId: number,
  data: any,
) => {
  return apiRequest({
    url: getUrl(`/maintenance/maintenanceorders/${orderId}/service-center`),
    method: 'POST',
    jsonBody: data,
  })
}

export const maintenanceEditEquipmentData = (
  params: MaintenanceEditEquipmentDataParams,
) => {
  return apiRequest({
    url: getUrl(`/maintenance/maintenanceorders/edit-equipment-data`),
    method: 'POST',
    jsonBody: params,
  })
}

export const getRequestStatistic = (
  params: RequestsStatisticFilterType,
): Promise<RequestStatisticResponse> => {
  const queryStingParams = buildParams(params)

  return apiRequest({
    url: getUrl(
      `/statistics/created-orders-distribution-funnel?${queryStingParams}`,
    ),
    method: 'GET',
  })
}

export const getSimilarLocalities = (params: {
  id: number
  search: string
}): Promise<SimilarCitiesResponse> => {
  const queryStingParams = buildParams(params)

  return apiRequest({
    url: getUrl(`/location/locality?${queryStingParams}`),
    method: 'GET',
  })
}

export const mergeCities = (
  localityId: number,
  body: number[],
): Promise<void> => {
  return apiRequest({
    url: getUrl(`/location/locality/${localityId}/merge`),
    method: 'POST',
    jsonBody: body,
  })
}

export const updateCity = (
  localityId: number,
  body: CreateCityForm,
): Promise<CreateCityForm> => {
  return apiRequest({
    url: getUrl(`/location/locality/${localityId}`),
    method: 'PATCH',
    jsonBody: body,
  })
}

export const createNewCity = (
  body: CreateCityForm,
): Promise<CreateCityForm> => {
  return apiRequest({
    url: getUrl(`/location/locality`),
    method: 'POST',
    jsonBody: body,
  })
}

export const getMaintenanceReports = (
  params: MaintenanceReportsParams,
): Promise<MaintenanceReportResponse> => {
  const { appVersion = null, ...otherParams } = params
  const queryStingParams = buildParams(otherParams)
  const headers: Record<string, any> = {}
  if (appVersion) {
    headers['App-Version'] = appVersion
  }

  return apiRequest({
    url: getUrl(`/maintenance/reports/paged?${queryStingParams}`),
    method: 'GET',
    headers,
  })
}

export const getSuitableRequestsForServiceReports = (
  reportId: number,
  params: any,
): Promise<MaintenanceOrderResponse> => {
  const queryStingParams = buildParams(params)

  return apiRequest({
    url: getUrl(
      `/maintenance/reports/${reportId}/orders/suitable?${queryStingParams}`,
    ),
    method: 'GET',
  })
}

export const addServiceRequestsToReport = (
  reportId: number,
  body: {
    orderIds: number[]
  },
): Promise<void> => {
  return apiRequest({
    url: getUrl(`/maintenance/reports/${reportId}/orders`),
    method: 'POST',
    jsonBody: body,
  })
}

export const getSingleMaintenanceReport = (
  reportId: number | string,
): Promise<MaintenanceReport> => {
  return apiRequest({
    url: getUrl(`/maintenance/reports/${reportId}`),
    method: 'GET',
  })
}

export const getHistoryServiceStatistic = (
  params: any,
): Promise<RegionStats> => {
  const queryStingParams = buildParams(params)
  return apiRequest({
    url: getUrl(`/statistics/processed-maintenance-orders?${queryStingParams}`),
    method: 'GET',
  })
}

export const getNewServiceOrders = (
  params: MaintenanceOrdersParams,
): Promise<MaintenanceOrderResponse> => {
  const queryStingParams = buildParams(params)
  return apiRequest({
    url: getUrl(`/maintenance/maintenanceorders/paged?${queryStingParams}`),
    method: 'GET',
  })
}

export const createServiceReport = (
  body: CreateReportBodyType,
): Promise<number> => {
  return apiRequest({
    url: getUrl(`/maintenance/reports`),
    method: 'POST',
    jsonBody: body,
  })
}

export const removeFromArchive = (body: {
  orderIds: number[]
}): Promise<number> => {
  return apiRequest({
    url: getUrl(`/orders/archive`),
    method: 'DELETE',
    jsonBody: body,
  })
}

export const startDataCheckingServiceReport = (
  reportId: number,
): Promise<void> => {
  return apiRequest({
    url: getUrl(`/maintenance/reports/${reportId}/start-data-checking`),
    method: 'POST',
  })
}

export const forceCloseServiceReport = (reportId: number): Promise<void> => {
  return apiRequest({
    url: getUrl(`/maintenance/reports/${reportId}/force-close`),
    method: 'POST',
  })
}

export const checkAllServiceReportOrders = (
  reportId: number,
): Promise<void> => {
  return apiRequest({
    url: getUrl(`/maintenance/reports/${reportId}/orders/check`),
    method: 'POST',
  })
}

export const finishDataCheckingReportOrders = (
  reportId: number,
): Promise<void> => {
  return apiRequest({
    url: getUrl(`/maintenance/reports/${reportId}/complete-data-checking`),
    method: 'POST',
  })
}

export const finishDataClarifyingReportOrders = (
  reportId: number,
): Promise<void> => {
  return apiRequest({
    url: getUrl(`/maintenance/reports/${reportId}/complete-data-clarifying`),
    method: 'POST',
  })
}

export const commentServiceReport = (
  reportId: number,
  body: { comment: string },
): Promise<void> => {
  return apiRequest({
    url: getUrl(`/maintenance/reports/${reportId}/comment`),
    method: 'POST',
    jsonBody: body,
  })
}

export const sendServiceReportToOffice = (reportId: number): Promise<void> => {
  return apiRequest({
    url: getUrl(`/maintenance/reports/${reportId}/send-to-office`),
    method: 'POST',
  })
}

export const receiveServiceReport = (reportId: number): Promise<void> => {
  return apiRequest({
    url: getUrl(`/maintenance/reports/${reportId}/receive`),
    method: 'POST',
  })
}

export const checkReceiveServiceReport = (reportId: number): Promise<void> => {
  return apiRequest({
    url: getUrl(`/maintenance/reports/${reportId}/check-received-report`),
    method: 'POST',
  })
}

export const sendServiceReportToPayment = (reportId: number): Promise<void> => {
  return apiRequest({
    url: getUrl(`/maintenance/reports/${reportId}/proceed-to-payment`),
    method: 'POST',
  })
}
export const closeServiceReport = (reportId: number): Promise<void> => {
  return apiRequest({
    url: getUrl(`/maintenance/reports/${reportId}/close`),
    method: 'POST',
  })
}

export const toClarifyServiceRequest = (
  orderId: number,
  body: {
    comment: string
  },
): Promise<void> => {
  return apiRequest({
    url: getUrl(
      `/maintenance/reports/orders/${orderId}/clarification-required`,
    ),
    method: 'POST',
    jsonBody: body,
  })
}

export const checkServiceRequest = (
  orderId: number,
  reportId: number,
): Promise<void> => {
  return apiRequest({
    url: getUrl(`/maintenance/reports/${reportId}/orders/${orderId}/check`),
    method: 'POST',
  })
}

export const deleteServiceRequestsFromReport = (
  reportId: number,
  body: { orderIds: number[] },
): Promise<{ orderIds: number[] }> => {
  return apiRequest({
    url: getUrl(`/maintenance/reports/${reportId}/orders`),
    method: 'DELETE',
    jsonBody: body,
  })
}

export const dealerEndClarificationService = (
  orderId: number,
  body: {
    comment?: string
  },
): Promise<void> => {
  return apiRequest({
    url: getUrl(
      `/maintenance/reports/orders/${orderId}/complete-data-clarification`,
    ),
    method: 'POST',
    jsonBody: body,
  })
}

export const startDataClarifyingServiceReport = (
  reportId: number,
): Promise<void> => {
  return apiRequest({
    url: getUrl(`/maintenance/reports/${reportId}/start-data-clarifying`),
    method: 'POST',
  })
}

export const changeDataClarifyServiceRequest = (
  orderId: number,
  body: any,
): Promise<any> => {
  return apiRequest({
    url: getUrl(`/maintenance/maintenanceorders/${orderId}/maintenance-data`),
    method: 'POST',
    formData: body,
  })
}

export const getPrintServiceReportData = (
  reportId: number,
  body?: { appVersion: string },
): Promise<PrintServiceReportResponse> => {
  const headers = body ? { 'App-Version': body.appVersion } : {}

  return apiRequest({
    url: getUrl(`/maintenance/reports/${reportId}/print`),
    method: 'GET',
    headers,
  })
}
export const getCreateReportAllCheckboxes = (
  orderId: number,
): Promise<{ orderIds: number[] }> => {
  return apiRequest({
    url: getUrl(`/maintenance/maintenanceorders/${orderId}/reportable`),
    method: 'GET',
  })
}

export const getRequestReportAllCheckboxes = (
  orderId: number,
): Promise<{ orderIds: number[] }> => {
  return apiRequest({
    url: getUrl(`/orders/${orderId}/reportable`),
    method: 'GET',
  })
}

export const resentForDataCheckServiceReport = (
  reportId: number,
): Promise<void> => {
  return apiRequest({
    url: getUrl(`/maintenance/reports/${reportId}/resent-for-data-check`),
    method: 'POST',
  })
}

export const resentForDocumentsCheckServiceReport = (
  reportId: number,
): Promise<void> => {
  return apiRequest({
    url: getUrl(`/maintenance/reports/${reportId}/resent-for-documents-check`),
    method: 'POST',
  })
}
export const updateLinkedRequest = (
  orderId: number,
  body: ChangeLinkedRequestForm,
): Promise<void> => {
  return apiRequest({
    url: getUrl(`/maintenance/maintenanceorders/${orderId}/agreement`),
    method: 'POST',
    jsonBody: body,
  })
}

export const getSimilarAddressTable = (
  params: SimilarAddressParams,
): Promise<SimilarAddressTable> => {
  const queryStingParams = buildParams(params)
  return apiRequest({
    url: getUrl(
      `/statistics/installation-orders-address-groups?${queryStingParams}`,
    ),
    method: 'GET',
  })
}
